import { getApiRequest } from '@/utils'
import type { IRes } from '@/types'
import type { AxiosRequestConfig } from 'axios'

const request = getApiRequest()

export interface ModuleProductSettlementDetail {
  modelGroupList: IModelGroupList[]
  productId: number
  productImage: string
  productItemTotalPrice: string
  productModelName: string
  productName: string
  productPrice: string
  quantity: number
  status: number
  weight: number
  selected?: boolean
  productMark: number
  id: number
  isCustomAdd?: boolean
  selectedIds?: number[]
  isAdd?: boolean
  isAuto: boolean
  isRefresh: boolean
  isReplace: boolean
  productLabelList: string[]
}

export interface IModelGroupList {
  name: string
  value: number
  selected: boolean
  label: string
}

export interface ProductSettlementDetail {
  moduleProductItem: ModuleProductSettlementDetail[]
  modelGroupList: IModelGroupList[]
  productId: number
  productImage: string
  productItemTotalPrice: string
  productModelName: string
  productName: string
  productPrice: string
  quantity: number
  status: number
  isCustomAdd?: boolean
  weight: number
  isOpen?: boolean
  selected?: boolean
  indeterminate?: boolean
  productLabelList: string[]
  id: number
  isRefresh: boolean
  isAuto: boolean
  isReplace: boolean
  selectedIds?: number[]
  productMark: number
  categoryName: string
}

interface IDesignSettlementProps {
  totalAmount: string
  item: ProductSettlementDetail
}

//初始化结算列表
export async function designSettlement(id: number, config?: AxiosRequestConfig) {
  return request.get<IRes<IDesignSettlementProps>>(`/design/settlement/${id}`, config)
}

//获取弹窗分类菜单
export async function settlementCategoryMenu() {
  return request.get<IRes<unknown>>(`/design/settlement/category/menu`)
}

export interface Request {
  categoryId?: number
  current?: number
  size?: number
  search?: string
}
// 不带输入框的搜索
export async function settlementCategoryProduct(data: Request) {
  return request.post<IRes<IProductData>>(`/design/settlement/category/product`, data)
}

export interface SettlementProductProduct {
  productId: number
  productImage: string
  productMark: number
  productLabelList: string[]
  productModelName: string
  productName: string
  productPrice: number
  check?: boolean
}

export interface IProductData {
  productList: SettlementProductProduct[]
  total: number
  current: number
}

//带输入框的搜索
export async function settlementCategorySearch(data: Request) {
  return request.post<IRes<IProductData>>(`/design/settlement/product/search`, data)
}

export interface SettlementAddProjectDTOProduct {
  productId: number
  projectId: number
  projectMark: number
}

export interface SettlementAddProjectDTOProductRequest {
  productList: SettlementAddProjectDTOProduct[]
}
//弹窗 新增产品  新增的下拉菜单
export async function settlementProduct(data: SettlementAddProjectDTOProductRequest, config?: AxiosRequestConfig) {
  return request.post<IRes<IProductData>>(`/design/settlement/product`, data, config)
}

export interface productReplaceRequest {
  productId?: number
  templateId?: number | string
}

export interface ProductReplaceVO {
  productId: number
  productImage: string
  productLabelList: string[]
  productModelName: string
  productName: string
}

//获取替换产品
export async function productReplace(params: productReplaceRequest) {
  return request.get<IRes<ProductReplaceVO[]>>(`/design/product/replace`, { params })
}

export interface ProductPutRequest {
  id: number
  productId: number
}

// 替换产品 普通的下拉菜单切换
export async function settlementProductPut(data: ProductPutRequest, config?: AxiosRequestConfig) {
  return request.put<IRes<ProductReplaceVO[]>>(`/design/settlement/product`, data, config)
}

/**
 * CountrySiteListVO，数据对象
 */
export interface ICountry {
  currentSymbol: string
  currentCountryName: string
  currentCountryCode: string
  countryList: CountryList
  currentCurrency: string
  currentLanguage: string
  tel_prefix: string
  currentCountryId: number
}

export interface CountryList {
  source: Source[]
  sortLength: number
}

export interface Source {
  address_format_id: number
  countries_chinese_name: string
  countries_id: number
  countries_name: string
  iso_code: string
  tel_prefix: null | string
  states: State[]
  citys: City[]
}

export interface City {
  city_code: string
  city: string
}

export interface State {
  states_code: string
  states: string
}

// 获取国家
export async function countryList() {
  return request.get<IRes<ICountry>>(`/collector/api/website/siteMain`)
}

export interface settlementProductNumberRequest {
  id: number
  productNumber: number
}

//结算产品 数字输入框 增加 或者减少
export async function settlementProductNumber(data: settlementProductNumberRequest, config?: AxiosRequestConfig) {
  return request.put<IRes<ProductReplaceVO[]>>(`/design/settlement/product/number`, data, config)
}

// 产品结算重置所有
export async function settlementResetAllNumber(params: number, config?: AxiosRequestConfig) {
  return request.get<IRes<IDesignSettlementProps>>(`/design/settlement/${params}/reset/number`, config)
}

export interface settlementResetNumberRequest {
  projectId: number
  settlementId: number
}

// 产品结算单个刷新
export async function settlementResetNumber(params: settlementResetNumberRequest, config?: AxiosRequestConfig) {
  return request.get<IRes<IDesignSettlementProps>>(
    `/design/settlement/${params.projectId}/reset/number/${params.settlementId}`,
    config
  )
}

export interface DesignCaseCreateRequest {
  additionalServiceType?: number[]
  city: string
  communicationType?: number[]
  country: string
  customizeAdditionalServiceDes?: string
  deliverDate: string
  otherCommunicationDes?: string
  otherRequirements?: string
  phoneCommunicationDes?: string
  projectId: number
}

//新增case
export async function DesignCaseCreate(data: DesignCaseCreateRequest) {
  return request.post<IRes<IProductData>>(`/design/case/create`, data)
}

//新的Case
export async function DesignCaseCreateNew(data: DesignCaseCreateRequest) {
  return request.post<IRes<IProductData>>(`/design/case/build`, data)
}

interface IDesignCaseCreateProps {
  projectId: number
  productId: number
}
// 删除项
export async function settlementProductDelete(data: IDesignCaseCreateProps, config?: AxiosRequestConfig) {
  return request.delete<IRes<IProductData>>(`/design/settlement/${data.projectId}/product/${data.productId}`, config)
}

//批量删除光模块线缆
export async function settlementProductBatchDelete(data: IDesignCaseCreateProps) {
  return request.post<IRes<IProductData>>(`/design/settlement/delete-top`, data)
}

interface IProducts {
  products: Product[]
}

export interface Product {
  attributes?: { [key: string]: string }
  current_options_id?: number
  isChecked?: number
  products_id?: number
  qty?: number
}
// 结算前置操作
export async function DesignCaseBeforeCheckout(data: IProducts) {
  return request.post<IRes<unknown>>(`/collector/api/designCenter/beforeCheckout`, data)
}

//新增购物车
export async function CartNew(data: IProducts) {
  return request.post<IRes<unknown>>(`/collector/api/designCenter/addCart`, data)
}

//提交结算表单
export interface QuoteSubmitResult {
  case_number: number
}
export async function QuoteSubmit(data: unknown) {
  return request.post<IRes<QuoteSubmitResult>>(`/collector/api/quoteSubmit`, data)
}

export interface ISaveListRemark {
  listRemark?: string
  projectId: number
}

export async function ProductListRemarks(data: ISaveListRemark) {
  return request.post<IRes<unknown>>(`/design/export/save/productListRemarks`, data)
}

export async function FsCare(data: unknown) {
  return request.post<IRes<unknown>>(`/design/case/createFsCase`, data)
}

// 产品清单PDF导出DTO
export interface ProductListPdfDTO {
  /** 项目id */
  projectId: number
  /** 勾选的产品id列表 */
  productIdList?: number[]
}

// 导出产品清单PDF
export async function exportProductListPdf(data: ProductListPdfDTO) {
  return request.post<IRes<string>>(`/design/export/productList/pdf`, data, {
    responseType: 'blob',
  })
}

// ==================== 结算清单产品勾选状态管理 ====================

/**
 * 保存产品勾选状态DTO
 */
export interface SaveProductSelectionDTO {
  /** 项目ID */
  projectId: number
  /** 勾选的产品ID列表 */
  productIds: number[]
}

/**
 * 产品勾选状态查询参数
 */
export interface QueryProductSelectionParams {
  /** 项目ID */
  projectId: number
}

/**
 * 产品勾选状态响应数据
 */
export interface ProductSelectionResponse {
  /** 是否手动操作过勾选 */
  operatedSelect?: boolean
  /** 已勾选产品ID列表 */
  productIds?: number[]
}

/**
 * 保存结算清单产品勾选状态
 * @param data - 保存产品勾选状态参数
 * @returns 操作结果
 */
export async function saveProductSelection(data: SaveProductSelectionDTO, config?: AxiosRequestConfig) {
  return request.post<IRes<boolean>>(`/design/settlement/products/sesection/save`, data, config)
}

/**
 * 查询结算清单产品勾选状态
 * @param params - 查询参数（项目ID）
 * @returns 产品勾选状态列表
 */
export async function queryProductSelection(projectId: number, config?: AxiosRequestConfig) {
  return request.get<IRes<ProductSelectionResponse>>(`/design/settlement/products/selection/${projectId}`, config)
}
